import styled from 'styled-components';
import { mediaHelper, spacingHelper } from '@property.com.au/ui-kit';
import { FunctionComponent } from 'react';
import { MedianCostSubBrick } from '../MedianCostSubBrick/MedianCostSubBrick';
import { MarketInsightsPriceTrend } from '../../types';

const PriceTrendsContainer = styled.div`
  margin-top: ${spacingHelper('medium')};
`;

const PriceTrendContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: ${spacingHelper('extraSmall')};
  > * {
    ${mediaHelper('desktopMin')} {
      flex-grow: 1;
      width: 0;
    }
  }
`;

interface PriceTrendsProps {
  activePropertyType: string;
  priceTrends: MarketInsightsPriceTrend[];
}

export const PriceTrends: FunctionComponent<PriceTrendsProps> = ({
  activePropertyType,
  priceTrends,
}) => {
  return (
    <PriceTrendsContainer>
      {priceTrends.map(({ propertyType, medianPriceSubBrick, medianRentSubBrick }) => {
        if (propertyType !== activePropertyType || (!medianPriceSubBrick && !medianRentSubBrick))
          return null;

        return (
          <PriceTrendContainer key={`price-trend:${propertyType}`}>
            {medianPriceSubBrick && (
              <MedianCostSubBrick {...medianPriceSubBrick} graphId="median-price-sub-brick-graph" />
            )}
            {medianRentSubBrick && (
              <MedianCostSubBrick {...medianRentSubBrick} graphId="median-rent-sub-brick-graph" />
            )}
          </PriceTrendContainer>
        );
      })}
    </PriceTrendsContainer>
  );
};
